import "src/css/widgets/widgets.css";
import UserImage from "src/components/widgets/agent/userimage";
import PhoneStatus from "src/components/widgets/agent/phonestatus";
import FormStatus from "src/components/widgets/agent/formstatus";
import ChatStatus from "src/components/widgets/agent/chatstatus";

function Agent(props) {

    return (
        <div className={"d-flex align-items-center me-2 " + (props.agent.selected === true ? "bg-light-primary" : "")} style={{ padding: "10px", cursor: "pointer", borderRadius: "10px", margin: "10px" }} onClick={e => props.selectAgent(props.agent)}>
            <UserImage agent={props.agent} />
            <div className="w-100">
                <div className="fs-7 text-dark fw-bold w-100">{props.agent.name} </div>
                <div className="fs-7 text-muted fw-bold">{props.agent.ext}
                    <span className="text-primary float-end">
                        <PhoneStatus agent={props.agent} />
                        <FormStatus agent={props.agent} />
                        <ChatStatus agent={props.agent} />
                    </span>
                </div>
            </div>
        </div>
    )
}


export default Agent;